export default "__VITE_ASSET__CdIHx3tM__"